import axios from 'axios'
export function saveSupplier (data) {
  return axios.post(`/manage/supplier/save`, data)
}

export function editSupplier (data) {
  return axios.post(`/manage/supplier/edit`, data)
}
export function getSupplierList (data) {
  return axios.get(`/manage/supplier/list`, { params: data })
}
export function logicDelete (data) {
  return axios.get(`/manage/supplier/logicDelete`, { params: data })
}
export function getSupplierDetail (data) {
  return axios.get(`/manage/supplier/querySupplierById`, { params: data })
}

export function getvehicleDetailList (data) {
  return axios.get(`/manage/vehicleDetail/list`, { params: data })
}
export function saveVehicle (data) {
  return axios.post(`/manage/vehicleDetail/save`, data)
}
export function getVehicleDetail (data) {
  return axios.get(`/manage/vehicleDetail/selectById`, { params: data })
}
export function editVehicle (data) {
  return axios.post(`/manage/vehicleDetail/edit`, data)
}
export function deleteLogic (data) {
  return axios.get(`/manage/vehicleDetail/deleteLogic`, { params: data })
}